import { render, staticRenderFns } from "./point-edit-page.vue?vue&type=template&id=9b401af0&"
import script from "./point-edit-page.vue?vue&type=script&lang=ts&"
export * from "./point-edit-page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports